import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import { make } from 'vuex-pathify'

Vue.use(Vuex)
const state = {
    isOnline: false,
    isAuthenticated: false,
    token: '',
    crmTokenValidTill: 0,
    u: '',
    apiUrl: '',
    leadEmailHelper: ''
}
const mutations = make.mutations(state)
export default new Vuex.Store({
  plugins: [pathify.plugin],
  state,
  mutations,
  actions: {
  }
})
